import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { Row, Col, Button, Card, Form, Badge } from 'react-bootstrap';

import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { getTaskNumbers } from '../../../../services/TaskNumberService';
import { useLoader } from '../../../../context/LoaderCotext';
import { getMTEByEmail } from '../../../../services/MTEService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import Swal from 'sweetalert2';

import { clearDatabase, retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/AxiosInstance';
import { deleteTrainingFile } from '../../../../services/FileService';
import { getCourseTypes, getCourseTypesList } from '../../../../services/CourseTypeService';
import { createTraininghistory } from '../../../../services/TraininghistoryService';

const validationSchema = Yup.object({
  employeeName: Yup.object().required('Employee Name Required'),
  employeeNumber: Yup.string().required('Employee Number Required'),
  date: Yup.date().required('Date Required'),
  phoneNumber: Yup.string().required('Contact Number Required'),
  chargeCode: Yup.string().required('Charge Code Required'),
  courseType: Yup.string().required('Course Type Required'),
  program: Yup.string().required('Program Name Required'),
  educationalBackground: Yup.string().required('Educatinal Background Required'),
  nameOfTrainingProgram: Yup.string().required('Name of Training Required'),
  location: Yup.string().required('Location Required'),
  descriptionOfTrainingProgram: Yup.string().required('Desription Required'),
  trainingStart: Yup.date().required('Start Date Required'),
  trainingEnds: Yup.date()
    .min(Yup.ref('trainingStart'), 'End date must be after start date')
    .required('Training Ends Date Required'),
  trainingCost: Yup.number(),
  trainingJustification: Yup.string().required('Training Justification Required'),
  customCourse: Yup.string().test(
    'required-if-other',
    'Please enter a course type',
    function (value) {
      return this.parent.courseType === 'other' ? !!value : true;
    }
  ),
  attachments: Yup.array()
    .min(
      1,
      'At least one file is required or selected file is not supporting, please select (jpeg, jpg, png, pdf).'
    ) // Ensures that at least one file is selected
    .of(
      Yup.mixed()
        .test(
          'fileType',
          'Unsupported file format, please select (jpeg, jpg, png, pdf).',
          (file) => {
            return file && SUPPORTED_FORMATS.includes(file.type);
          }
        )
        .test('fileSize', 'File is too large, please select smaller file', (file) => {
          return file && file.size <= 50000000; // Max file size of 50MB
        })
    )
    .required('Attachments are required'), // This ensures the array is not empty
});
const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

const TrainingForm = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [uploadProgress, setUploadProgress] = useState({}); // To track progress for each file
  const [attachments, setAttachments] = useState([]);
  const [courseTypeList, setCourseTypeList] = useState([]);
  const [initialValues, setInitialValues] = useState({
    employeeName: '',
    employeeNumber: '',
    date: moment().format('MM/DD/YYYY'),
    phoneNumber: '',
    chargeCode: '',
    courseType: '',
    customCourse: '',
    program: '',
    educationalBackground: '',
    nameOfTrainingProgram: '',
    location: '',
    descriptionOfTrainingProgram: '',
    trainingStart: '',
    trainingEnds: '',
    trainingCost: 0,
    trainingJustification: '',
    attachments: [],
    manager: '',
    boxFolderId: '310099883829',
    boxFolderName: 'Training-Forms',
    timestamp: moment().unix(),
  });

  const chargeCodeList = [
    {
      label: 'FRNGE.105.06.MGR.001 Training - Corp/Infrastru HR',
      value: 'FRNGE.105.06.MGR.001 Training - Corp/Infrastru HR',
    },
    {
      label: 'FRNGE.105.06.MGR.002 Training - Ray Baldon - CTO',
      value: 'FRNGE.105.06.MGR.002 Training - Ray Baldon - CTO',
    },
    {
      label: 'FRNGE.105.06.MGR.003 Training - Susan Howell - SAMDA',
      value: 'FRNGE.105.06.MGR.003 Training - Susan Howell - SAMDA',
    },
    {
      label: 'FRNGE.105.06.MGR.004 Training - Paola Contreras Marroquin - Contracts',
      value: 'FRNGE.105.06.MGR.004 Training - Paola Contreras Marroquin - Contracts',
    },
    {
      label: 'FRNGE.105.06.MGR.005 Training - Belay Ademu - Accounting',
      value: 'FRNGE.105.06.MGR.005 Training - Belay Ademu - Accounting',
    },
    {
      label: 'FRNGE.105.06.MGR.006 Training - Rachit Mahajan - CFO',
      value: 'FRNGE.105.06.MGR.006 Training - Rachit Mahajan - CFO',
    },
    {
      label: 'FRNGE.105.06.MGR.008 Training - Terrance Sumter - Facilities',
      value: 'FRNGE.105.06.MGR.008 Training - Terrance Sumter - Facilities',
    },
    {
      label: 'FRNGE.105.06.MGR.010 Training - David McBride - COO',
      value: 'FRNGE.105.06.MGR.010 Training - David McBride - COO',
    },
    {
      label: 'FRNGE.105.06.MGR.011 Training - Oreste Reale - Grants',
      value: 'FRNGE.105.06.MGR.011 Training - Oreste Reale - Grants',
    },
    {
      label: 'FRNGE.105.06.MGR.012 Training - Susan Howell - HBG',
      value: 'FRNGE.105.06.MGR.012 Training - Susan Howell - HBG',
    },
    {
      label: 'FRNGE.105.06.MGR.014 Training - Chris Williamson - CSO',
      value: 'FRNGE.105.06.MGR.014 Training - Chris Williamson - CSO',
    },
    {
      label: 'FRNGE.105.06.MGR.015 Training - David McBride - ESES',
      value: 'FRNGE.105.06.MGR.015 Training - David McBride - ESES',
    },
    {
      label: 'FRNGE.105.06.OTH.001 Tuition & Training',
      value: 'FRNGE.105.06.OTH.001 Tuition & Training',
    },
  ];
  // Training Costs ()
  useEffect(() => {
    setFolderAPISuccess(true);
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  useEffect(() => {
    const fetchCourseType = async () => {
      const response = await getCourseTypesList();
      response.push({ label: 'Other', value: 'other' });
      setCourseTypeList(response);
    };
    fetchCourseType();
  }, []);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue, date = moment().toDate()) => {
    setFieldValue(`employeeName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`manager`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    const getManager = await getMTEByEmail(selectedOption.email);
    if (typeof getManager == 'undefined' && profile.role.toLowerCase() != 'admin') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Manager is not configured for selected employee, please contact admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`email`, '');
      setFieldValue(`manager`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    setFieldValue(`manager`, getManager.manager || 'Not assigned');
    setFieldValue(`boxFolderId`, '310099883829');
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'training-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = async (data) => {
    console.log('Form Submitted Data:', data);
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        employeeName: data.employeeName.value,
        attachments: attachments, // Send only the server-side filenames
        boxFolderId: '310099883829',
      };
      handleUploadBatch(payloadForms);
      await createTraininghistory({
        employeeName: data.employeeName.value,
        employeeNumber: data.employeeNumber,
        employeeEmail: data.employeeEmail,
        date: data.date,
        phoneNumber: data.phoneNumber,
        chargeCode: data.chargeCode,
        courseType: data.courseType,
        customCourse: data.customCourse,
        program: data.program,
        educationalBackground: data.educationalBackground,
        nameOfTrainingProgram: data.nameOfTrainingProgram,
        location: data.location,
        descriptionOfTrainingProgram: data.descriptionOfTrainingProgram,
        trainingStart: data.trainingStart,
        trainingEnds: data.trainingEnds,
        trainingCost: data.trainingCost,
        trainingJustification: data.trainingJustification,
        manager: data.manager,
        isApproved: 'true',
      });
    }
  };

  const handleFileChange = (event, setFieldValue, currentValues, setErrors) => {
    const files = Array.from(event.target.files);
    if (files.length <= 0) {
      setFieldValue('attachments', []);
      setAttachments([]);
    }

    // Validate the files before uploading them
    const validatedFiles = files.filter((file) => {
      const isValidType = SUPPORTED_FORMATS.includes(file.type);
      const isValidSize = file.size <= 50000000; // 50MB file size limit
      return isValidType && isValidSize;
    });

    if (validatedFiles.length === 0) {
      // If no valid files, set Formik error and prevent submission
      setErrors({
        attachments:
          'No valid files selected. Please upload valid files, please select (jpeg, jpg, png, pdf).',
      });
      return;
    }

    // Append new files to the existing array of files
    const updatedFiles = currentValues.attachments
      ? [...currentValues.attachments, ...files]
      : files;

    // Update Formik field value
    setFieldValue('attachments', updatedFiles);
    // Update the selected files state to include the new files
    setAttachments((prev) => [...prev, ...files]);
    // Upload each validated file
    validatedFiles.forEach(uploadFile);
  };

  // Remove a file from the attachments
  const handleRemoveFile = (index, setFieldValue, values, file) => {
    deleteTrainingFile(file.name)
      .then(() => {
        setAttachments((prevFiles) => prevFiles.filter((f) => f.name !== file.name));

        const newFiles = values.attachments.filter((_, i) => i !== index);
        setFieldValue('attachments', newFiles);
        // Clear the file input if no files are left
        if (newFiles.length === 0) {
          setFieldValue('attachments', []);
          setAttachments([]); // Clear the field as an empty array
        }

        setUploadProgress((prev) => {
          const newProgress = { ...prev };
          delete newProgress[file.name]; // Remove progress for the deleted file
          return newProgress;
        });
      })
      .catch((error) => {
        console.error('Error deleting file:', error);
      });
  };

  // Upload a single file
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('files', file); // Append the single file to FormData
    // Start upload for this specific file
    await axiosInstance
      .post('file/training-uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure the content type is set correctly
        },
        onUploadProgress: (progressEvent) => {
          // Safeguard to ensure total is not undefined
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            // Update the progress for this specific file using file.name
            setUploadProgress((prev) => ({
              ...prev,
              [file.name]: percentCompleted,
            }));
          }
        },
        timeout: 600000,
      })
      .then((response) => {
        const fileInfo = {
          name: response.data[0].fileName, // Get the server-generated name
          originalName: file.name, // Keep the original file name
        };
        setAttachments((prevFiles) => [
          ...prevFiles.filter((f) => f.name !== file.name), // Remove old entry if exists
          fileInfo, // Add new uploaded file info
        ]);
        setUploadProgress((prev) => ({
          ...prev,
          [file.name]: 100, // Set 100% progress after successful upload
        }));
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        // Optionally, handle the error state for the specific file
      });
  };

  return (
    <>
      <PageTitle pageTitle="Application for Training" />

      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', paddingBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1819824954046"
          >
            Instruction to Submit the Training form
          </Link>
        </div>
        <Card.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, setErrors, errors, touched }) => (
              <FormikForm>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="employeeName">Employee Name</label>
                      <AsyncSelect
                        name="employeeName"
                        loadOptions={loadOptions}
                        defaultOptions={employeeList}
                        placeholder="Select Employee Name"
                        isSearchable
                        onChange={(selectedOption) =>
                          handleEmployeeChange(selectedOption, setFieldValue)
                        }
                        value={values.employeeName}
                      />
                      <ErrorMessage name="employeeName" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="employeeNumber">Employee Number</label>
                      <Field
                        type="text"
                        name="employeeNumber"
                        className="form-control"
                        placeholder="Employee Number"
                        value={values.employeeNumber}
                        readOnly
                      />
                      <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="date">Date</label>
                      <Field
                        type="text"
                        name="date"
                        className="form-control"
                        placeholder="MM/DD/YYYY"
                        value={values.date}
                        readOnly
                      />
                      <ErrorMessage name="date" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="phoneNumber">Phone Number</label>
                      <Field
                        type="text"
                        name="phoneNumber"
                        className="form-control"
                        placeholder="123-456-7890"
                        value={values.phoneNumber}
                      />
                      <ErrorMessage name="phoneNumber" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="chargeCode">Charge Code</label>
                      <Select
                        name="chargeCode"
                        options={chargeCodeList}
                        placeholder="Select Charge Code"
                        isSearchable
                        onChange={(selectedOption) =>
                          setFieldValue('chargeCode', selectedOption.label)
                        }
                      />
                      <ErrorMessage name="chargeCode" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="courseType">Course Type</label>
                      <Select
                        name="courseType"
                        options={courseTypeList}
                        placeholder="Select Course Type"
                        isSearchable
                        onChange={(selectedOption) => {
                          setFieldValue('courseType', selectedOption.value);
                          if (selectedOption.value === 'other') {
                            setFieldValue('customCourse', ''); // Reset custom field
                          }
                        }}
                      />
                      <ErrorMessage name="courseType" component="div" className="text-danger" />
                    </div>
                  </Col>
                  {values.courseType === 'other' && (
                    <Col>
                      <div className="form-group">
                        <label htmlFor="customCourse">Other Course Type</label>
                        <Field
                          type="text"
                          name="customCourse"
                          className="form-control"
                          placeholder="Enter course type"
                          value={values.customCourse}
                        />
                        <ErrorMessage name="customCourse" component="div" className="text-danger" />
                      </div>
                    </Col>
                  )}
                  <Col>
                    <div className="form-group">
                      <label htmlFor="program">Program / Department</label>
                      <Field
                        type="text"
                        name="program"
                        className="form-control"
                        placeholder="Program / Department"
                        value={values.program}
                      />
                      <ErrorMessage name="program" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="educationalBackground">Educational Background</label>
                      <Field
                        as="textarea"
                        name="educationalBackground"
                        className="form-control"
                        placeholder="Educational Background"
                        value={values.educationalBackground}
                      />
                      <ErrorMessage
                        name="educationalBackground"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="nameOfTrainingProgram">Name of Training Program</label>
                      <Field
                        type="text"
                        name="nameOfTrainingProgram"
                        className="form-control"
                        placeholder="Name of Training Program"
                        value={values.nameOfTrainingProgram}
                      />
                      <ErrorMessage
                        name="nameOfTrainingProgram"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="location">Location / Institution Name</label>
                      <Field
                        type="text"
                        name="location"
                        className="form-control"
                        placeholder="Location/Institution name"
                        value={values.location}
                      />
                      <ErrorMessage name="location" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="descriptionOfTrainingProgram">
                        Description of Training Program
                      </label>
                      <Field
                        as="textarea"
                        name="descriptionOfTrainingProgram"
                        className="form-control"
                        placeholder="Description of Training Program"
                        value={values.descriptionOfTrainingProgram}
                      />
                      <ErrorMessage
                        name="descriptionOfTrainingProgram"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="trainingJustification">Training Justification</label>
                      <Field
                        as="textarea"
                        name="trainingJustification"
                        className="form-control"
                        placeholder="Training Justification"
                        value={values.trainingJustification}
                      />
                      <ErrorMessage
                        name="trainingJustification"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="trainingStart">Training Start</label>
                      <DatePicker
                        selected={values.trainingStart}
                        onChange={(trainingStart) => {
                          setFieldValue('trainingStart', trainingStart);
                        }}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        value={values.trainingStart}
                      />
                      <ErrorMessage name="trainingStart" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="trainingEnds">Training Ends</label>
                      <DatePicker
                        selected={values.trainingEnds}
                        onChange={(trainingEnds) => {
                          setFieldValue('trainingEnds', trainingEnds);
                        }}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        value={values.trainingEnds}
                      />
                      <ErrorMessage name="trainingEnds" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="trainingCost">Training Cost ($)</label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Field
                          type="number"
                          name="trainingCost"
                          className="form-control"
                          placeholder="Training Cost"
                          min="0"
                          step="1"
                          value={values.trainingCost}
                        />
                      </div>
                      <ErrorMessage name="trainingCost" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex flex-column justify-content-start" md={6}>
                    <Form.Group>
                      <Form.Label htmlFor="custom-file">
                        Choose File
                        <strong>
                          &nbsp;&nbsp;&nbsp;&nbsp;(Please attach a copy of training description(s)
                          and proof of training fee costs)
                        </strong>
                      </Form.Label>
                      <Form.Control
                        name={'attachments'}
                        id="custom-file"
                        type="file"
                        multiple
                        onChange={(e) => handleFileChange(e, setFieldValue, values, setErrors)}
                      />
                      {/* Display validation errors from Yup */}
                      {errors.attachments && touched.attachments && (
                        <div className="text-danger">
                          {/* If it's an array, map over the errors */}
                          {Array.isArray(errors.attachments) ? (
                            errors.attachments.map((error, index) => <div key={index}>{error}</div>)
                          ) : (
                            /* If it's a string (e.g., "attachments is required"), display it directly */
                            <div>{errors.attachments}</div>
                          )}
                        </div>
                      )}
                    </Form.Group>

                    {/* Display selected attachments */}
                    {values.attachments.length > 0 && (
                      <div className="mt-2">
                        <strong>Selected Files:</strong>
                        <Col md={8}>
                          <ul>
                            {attachments.map((file, index) => {
                              const progressPercentage =
                                (uploadProgress[file.name]
                                  ? uploadProgress[file.name]
                                  : uploadProgress[file.originalName]) || 0;

                              return (
                                <li
                                  key={file.name}
                                  style={{
                                    marginBottom: '10px',
                                    textAlign: 'left',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <div style={{ flexGrow: 1 }}>
                                      <strong>{file.originalName}</strong> - {progressPercentage}%
                                      <progress
                                        value={progressPercentage}
                                        max="100"
                                        style={{
                                          display: 'block',
                                          width: '100%',
                                          marginTop: '5px',
                                        }} // Added margin for spacing
                                      />
                                    </div>
                                    <Badge
                                      style={{
                                        marginLeft: '20px',
                                        alignSelf: 'flex-start',
                                      }} // Align button properly
                                      variant="danger"
                                      size="sm"
                                      bg="danger"
                                      onClick={() =>
                                        handleRemoveFile(index, setFieldValue, values, file)
                                      }
                                      className="ml-2 mt-4"
                                    >
                                      <i className="fa fa-solid fa-close"></i>
                                    </Badge>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </Col>
                      </div>
                    )}
                  </Col>
                  <Col className="d-flex justify-content-end mt-4" style={{ paddingTop: '7px' }}>
                    <Button variant="primary" style={{ height: 'max-content' }} type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(TrainingForm);
